module.exports = __webpack_public_path__ + "media/images/documents/pdf-format-977516b426204eb3a8ef2b008ac56d05.png";